/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
  Route, Routes,
} from 'react-router-dom';
import CompaniesContainer from "./CompaniesContainer";
import Company from "./Company";
import CompanyJsonView from "./CompanyJsonView";
import CompanyProfileView from "./CompanyProfileView";

export default class CompaniesRouter extends Component {
  static propTypes = {

  };

  static defaultProps = {

  };

  render() { // eslint-disable-line
    return (
      <Routes>
        <Route path="/:id" element={<Company/>} />
        <Route path="/:id/view-as-json" element={<CompanyJsonView/>} />
        <Route path="/:id/profile" element={<CompanyProfileView/>} />
        <Route path="/" element={<CompaniesContainer/>} />
      </Routes>
    );
  }
}
